'use strict';

const computeDecimalRounding = function (value) {
  let decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};
module.exports = computeDecimalRounding;
